/**
 * Métadonnées des thèmes (aucune couleur ici : les valeurs vivent dans tokens.css).
 * Le thème s'applique via <html data-theme="…" data-mode="…">.
 *
 * Un seul thème depuis le 2026-09-28 : « Graphite » (ADR 0024). Les trois directions de J2
 * (`or`, `ultraviolet`, `signal`) sont retirées ; un identifiant mémorisé qui n'est plus dans
 * cette liste retombe sur DEFAULT_THEME (`isThemeId`). La liste reste un tableau : c'est l'entrée
 * d'une marque blanche par locataire, qui ajoutera un thème sans changer le mécanisme.
 */
export const THEMES = [{ id: 'graal', letter: 'G', name: 'Graphite', recommended: true }] as const;

export type ThemeId = (typeof THEMES)[number]['id'];

export const MODES = ['dark', 'light'] as const;
export type Mode = (typeof MODES)[number];

export const DEFAULT_THEME: ThemeId = 'graal';
export const DEFAULT_MODE: Mode = 'dark';

export function isThemeId(value: unknown): value is ThemeId {
  return THEMES.some((theme) => theme.id === value);
}

export function isMode(value: unknown): value is Mode {
  return MODES.some((mode) => mode === value);
}

/** Applique un thème sur un élément racine (par défaut <html>). */
export function applyTheme(theme: ThemeId, mode: Mode, root: HTMLElement = document.documentElement): void {
  root.dataset.theme = theme;
  root.dataset.mode = mode;
}
